export default "__VITE_ASSET__DjGsQnRE__"